import React, {Component} from 'react';
import PropTypes from 'prop-types';

import * as PL from 'react-patterns';

const Input = PL.form.Input;
const Disclaimer = PL.typography.textblock.Disclaimer;

const pad = (x, padChars = '') => x ? x + padChars : '';

class RexForm extends Component {
  static propTypes = {
    user: PropTypes.any,
    mainProduct: PropTypes.any,
    pinCode: PropTypes.string,
    updateForm: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      delivery: 'email',
      showOtherEmail: false,
      pinCodeEntered: false,
      pinCode: null,
      otherEmail: ''
    };
  }

  selectDelivery = (e) => {
    let showOtherEmail = e.target.value === 'otherEmail';
    this.setState({ delivery: e.target.value, showOtherEmail });
    this.props.updateForm({ delivery: e.target.value});
  };

  handleOtherEmail = (e) => {
    this.setState({ otherEmail: e.target.value });
    this.props.updateForm({ otherEmail: e.target.value});
  };

  handlePinCode = (e) => {
//    this.setState({ pinCode: e.target.value });
    this.props.updateForm({pinCode: e.target.value});
  };

  render() {
    const { user, mainProduct } = this.props;

    const pinURL = `https://verkkoasiointi.elisa.fi/viihde-online/tunnukset/${mainProduct.customerId}/${mainProduct.id}`;

    let address = '';
    if (user.address) {
      address += pad(user.address.street, ', ');
      address += pad(user.address.zipCode, ' ');
      address += pad(user.address.city);
    }

    return (
      <div id="rexForm">
        <fieldset className="ea-radio ea-radio--list">
          <legend className="ea-radio__legend ea-h4">Tilausvahvistus toimitetaan osoitteeseen:</legend>

          <input type="radio" id="address_1" name="deliver" value="email" checked={this.state.delivery === 'email'}
                 onChange={this.selectDelivery}/>
          <label htmlFor="address_1">
            <span className="ea-radio__icon"><span className="ea-radio__icon-inner"></span></span>
            <div>
              <div>{user.email}</div>
            </div>
          </label>

          { address &&
          <div>
            <input type="radio" id="address_2" name="deliver" value="post"
                   checked={this.state.delivery === 'post'} onChange={this.selectDelivery}/>
            <label htmlFor="address_2">
              <span className="ea-radio__icon"><span className="ea-radio__icon-inner"></span></span>
              <div>
                <div>{address}</div>
              </div>
            </label>
          </div>
          }

          <input type="radio" id="address_3" name="deliver" value="otherEmail" checked={this.state.delivery === 'otherEmail'}
                 onChange={(e) => this.selectDelivery(e)}/>
          <label htmlFor="address_3"><span className="ea-radio__icon"><span
            className="ea-radio__icon-inner"></span></span>Muu sähköposti</label>
        </fieldset>

        { this.state.showOtherEmail &&
        <div id="address">
          <Input label="Sähköpostiosoite"
                 name="other_email"
                 value={this.state.otherEmail}
                 type="text"
                 onChange={this.handleOtherEmail}/>
          <Disclaimer>Jos haluat pysyvästi muuttaa tietoja, se tapahtuu OmaElisassa.</Disclaimer>
        </div>
        }

        { !user.isImpersonated &&
        <div>
          <h4 className="ea-h4 ea-pad--pad-top-2">Syötä PIN-koodisi:</h4>
            <div className="ea-input" style={{ width: "15rem" }}>
            <div className="ea-input__wrapper">
              <input type="password"
                     style={{ width: "calc(100% - 37px)"}}
                     name="pin_code"
                     className="ea-input__input"
                     value={this.props.pinCode}
                     placeholder=""
                     required
                     maxLength={4}
                     onChange={this.handlePinCode}/>
              <span className="ea-input__addon ea-input__addon--auto-status"></span>
            </div>
          </div>
          <Disclaimer>
            Elisa Viihteen PIN-koodin löydät <a href={pinURL} target="_blank">OmaElisasta</a>.
          </Disclaimer>
        </div>
        }
      </div>
    );
  }
}

export default RexForm;



// WEBPACK FOOTER //
// ./web/js/components/rex/Form.js